import { render } from "./ComponentWrapper.vue?vue&type=template&id=f924f25e&scoped=true&lang=html"
import script from "./ComponentWrapper.vue?vue&type=script&lang=js"
export * from "./ComponentWrapper.vue?vue&type=script&lang=js"

import "./ComponentWrapper.vue?vue&type=style&index=0&id=f924f25e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f924f25e"

export default script